import { Col } from 'react-bootstrap';
import { SubSectionHeading, HeadingDesc } from '../../../Components/Headings';
import { SimpleButton } from '../../../Components/button';
import CallToAction from '../../../Components/callToAction/CallToAction';
import img1 from '../../../assets/images/png/ai_tech.png';
import './signalAITechnologies.css';

function SignalAITechnologies() {
  return (
    <section className="signalAITechnologies">
      <CallToAction
        leftContent={<LeftContent />}
        rightContent={<RightConten />}
      />
    </section>
  );
}

function LeftContent() {
  return (
    <Col md={4}>
      <div className="box_img">
        <img src={img1} alt="signalAITechnologies" />
      </div>
    </Col>
  );
}

function RightConten() {
  return (
    <Col md={7} className="offset-lg-1">
      <div>
        <SubSectionHeading text="Signal Processing and AI Technologies" />
        <HeadingDesc text="The video stream is analyzed with advanced AI and deep learning algorithms, including computer vision technology and signal processing. No identifiable features or demographic data (e.g., eyes, height, gender, weight, etc.) are needed. In approximately one minute, users can measure blood pressure, heart rate, heart rate variability (SDNN and/or RRi raw data), oxygen saturation, respiration rate, sympathetic stress, parasympathetic activity and pulse-respiration quotient." />
        <HeadingDesc text="Meri Sehat’s technology runs on the device, enabling users to perform scans without connection to the internet. (Please note, when offline, results will not be recorded in measurement history.)" />
        <SimpleButton text="SCAN YOUR VITALS NOW" bgColor="#72D54A" />
      </div>
    </Col>
  );
}

export default SignalAITechnologies;
